import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight, ChevronDown, Star, ArrowRight, Car, Plane, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toursFaq as faqItems } from '../data/faq';

const services = [
  {
    id: 'rentals', icon: Car, path: '/rent-a-car',
    titleRo: 'Închirieri Auto', titleEn: 'Car Rentals',
    descRo: 'Închiriază autoturisme moderne pentru călătorii în Brașov și oriunde în România. Flexibilitate, confort și servicii profesionale pentru fiecare drum.',
    descEn: 'Rent modern cars for trips in Brașov and anywhere in Romania. Flexibility, comfort and professional services for every journey.',
    priceRo: '', priceEn: '',
    image: '/images/rentals-cover.webp',
  },
  {
    id: 'transfers', icon: Plane, path: '/transfers',
    titleRo: 'Transfer Aeroport', titleEn: 'Airport Transfers',
    descRo: 'Transferuri private către Aeroportul Brașov-Ghimbav, București, Sibiu și orice destinație. Șoferi profesioniști, punctualitate și confort la fiecare cursă.',
    descEn: 'Private transfers to Brașov-Ghimbav Airport, Bucharest, Sibiu and any destination. Professional drivers, punctuality and comfort on every ride.',
    priceRo: '', priceEn: '',
    image: '/images/transfers-cover.webp',
  },
  {
    id: 'tours', icon: MapPin, path: '/tours',
    titleRo: 'Tururi Turistice', titleEn: 'Touristic Tours',
    descRo: 'Descoperă cele mai spectaculoase atracții din Brașov și România prin tururi private. Călătorește confortabil și bucură-te de experiențe memorabile.',
    descEn: 'Discover the most spectacular attractions in Brașov and Romania through private tours. Travel comfortably and enjoy memorable experiences.',
    priceRo: '', priceEn: '',
    image: '/images/tours-cover.webp',
  },
];

const googleReviews = [
  {
    name: 'Benedek Orsolya',
    rating: 5,
    timeAgo: '2 months ago',
    text: 'Very good service! I totally recommend it!',
  },
  {
    name: 'Roland Dezso',
    rating: 5,
    timeAgo: '2 months ago',
    text: 'Very nice!',
  },
  {
    name: 'ViaElite',
    rating: 5,
    timeAgo: '2 months ago',
    text: 'We use Montreon for our delegations and we have always been satisfied. Clean cars, a young and communicative team, flexible for any kind of situation. Thank you for the services provided!',
  },
  {
    name: 'Peter Olcsvari',
    rating: 5,
    timeAgo: '2 months ago',
    text: 'Amazing services. Very professional team, very clean cars and always punctual. We used them for our touristic tours near Brasov and the drivers were always very polite.',
  },
  {
    name: 'אביב ארץ',
    rating: 5,
    timeAgo: '1 month ago',
    text: 'Very nice guy, patience and kind. Took us from Brasov to Bran, and from Brasov to Bucharest the next day, totally recommend his services! Good price!',
  },
];


const whyChooseCards = [
  {
    icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    titleRo: 'Servicii Complete', titleEn: 'Complete Services',
    descRo: 'Închirieri auto, transferuri aeroport și tururi turistice premium, toate într-un singur loc. Oferim soluții complete de mobilitate pentru călătorii fără griji, în Brașov și oriunde în România.',
    descEn: 'Car rentals, airport transfers and premium touristic tours, all in one place. We offer complete mobility solutions for worry-free travel in Brașov and anywhere in Romania.',
  },
  {
    icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    titleRo: 'Siguranță și Încredere', titleEn: 'Safety & Trust',
    descRo: 'Flotă modernă, atent întreținută și servicii transparente, concepute pentru confortul și siguranța fiecărui client. Călătorești cu încredere de la început până la destinație.',
    descEn: 'Modern fleet, carefully maintained and transparent services, designed for the comfort and safety of every client. Travel with confidence from start to destination.',
  },
  {
    icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
    titleRo: 'Flexibilitate Totală', titleEn: 'Total Flexibility',
    descRo: 'Ridicare și predare flexibilă, program adaptat și servicii personalizate pentru orice tip de călătorie. Ne adaptăm planurilor tale, nu invers.',
    descEn: 'Flexible pickup and drop-off, adapted schedule and personalized services for any type of journey. We adapt to your plans, not the other way around.',
  },
  {
    icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
    titleRo: 'Atenția la Detalii', titleEn: 'Attention to Detail',
    descRo: 'Punem accent pe punctualitate, atenție la detalii și servicii la standarde înalte. Fiecare călătorie este concepută pentru a oferi confort, profesionalism și o experiență memorabilă.',
    descEn: 'We focus on punctuality, attention to detail and high-standard services. Every journey is designed to offer comfort, professionalism and a memorable experience.',
  },
];

/* ── Trust Row ─────────────────────────────────────── */

export const TrustRow = ({ isRo, items }) => {
  const defaultItems = [
    { textRo: 'Disponibilitate 24/7', textEn: '24/7 Availability', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
    { textRo: 'Echipă Profesionistă', textEn: 'Professional Team', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
    { textRo: 'Autoturisme Moderne', textEn: 'Modern Vehicles', icon: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10' },
    { textRo: 'Atenție la Detalii', textEn: 'Attention to Detail', icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z' },
  ];
  const trustItems = items || defaultItems;
  return (
  <section className="relative py-16 sm:py-20 overflow-hidden">
    <div className="absolute inset-0 parallax-bg" style={{ backgroundImage: 'url(/images/hero.webp)' }}>
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(13,27,62,0.92)' }}></div>
    </div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
      {/* Google Review Stars */}
      <div className="flex flex-col items-center mb-10">
        <div className="flex items-center gap-1 mb-2">
          {[1,2,3,4,5].map(i => (
            <svg key={i} className="w-7 h-7 text-[#FBBC04]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span className="text-white/70 text-sm font-medium">Google Reviews</span>
        </div>
      </div>

      {/* Trust Messages */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
        {trustItems.map((item, i) => (
          <div key={i} className="flex flex-col items-center text-center gap-3 py-3">
            <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20">
              <svg className="w-5 h-5 text-[#10B981]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
              </svg>
            </div>
            <span className="text-white text-sm font-semibold">{isRo ? item.textRo : item.textEn}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

/* ── Our Services ──────────────────────────────────── */

export const OurServices = ({ isRo }) => {
  const navigate = useNavigate();
  return (
    <section id="services" className="py-20 sm:py-28 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            {isRo ? 'Serviciile Noastre' : 'Our Services'}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#0D1B3E]">
            {isRo ? 'Servicii complete de mobilitate' : 'Complete mobility services'}
          </h2>
          <p className="font-body text-base text-gray-500 mt-3 max-w-xl mx-auto">
            {isRo
              ? 'De la închirieri auto și transferuri private până la experiențe turistice memorabile.'
              : 'From car rentals and private transfers to memorable touristic experiences.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <div key={service.id}
                className="group rounded-xl overflow-hidden border border-gray-200 hover:border-[#10B981]/50 hover:shadow-xl transition-all cursor-pointer bg-white"
                onClick={() => navigate(service.path)}
                data-testid={`service-card-${service.id}`}>
                <div className="aspect-[16/10] overflow-hidden bg-gray-100">
                  <img src={service.image} alt={isRo ? service.titleRo : service.titleEn} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-10 h-10 rounded-full bg-[#ECFDF5] flex items-center justify-center">
                      <Icon className="text-[#10B981]" size={20} />
                    </div>
                    {(isRo ? service.priceRo : service.priceEn) && (
                      <span className="text-[#10B981] text-sm font-bold">{isRo ? service.priceRo : service.priceEn}</span>
                    )}
                  </div>
                  <h3 className="font-display text-xl font-bold text-[#0D1B3E] mb-2">
                    {isRo ? service.titleRo : service.titleEn}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">
                    {isRo ? service.descRo : service.descEn}
                  </p>
                  <span className="inline-flex items-center text-[#10B981] text-sm font-semibold group-hover:gap-2 transition-all">
                    {isRo ? 'Află mai multe' : 'Learn more'}
                    <ArrowRight size={16} className="ml-1" />
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ── Why Choose Montréon ───────────────────────────── */

export const WhyChoose = ({ isRo }) => (
  <section className="relative py-24 sm:py-32 overflow-hidden">
    <div className="absolute inset-0 parallax-bg" style={{ backgroundImage: 'url(/images/transfers-cover.webp)' }}>
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.65), rgba(0,0,0,0.55), rgba(0,0,0,0.72))' }}></div>
    </div>
    <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
      <div className="text-center mb-14 sm:mb-18">
        <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
          {isRo ? 'De Ce Montréon' : 'Why Montréon'}
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
          {isRo ? 'De ce aleg călătorii Montréon?' : 'Why do travelers choose Montréon?'}
        </h2>
        <p className="font-body text-base text-white/60 max-w-2xl mx-auto">
          {isRo
            ? 'Montréon oferă servicii complete de mobilitate în Brașov și România, combinând închirieri auto, transferuri private și tururi turistice premium cu profesionalism, confort și flexibilitate.'
            : 'Montréon offers complete mobility services in Brașov and Romania, combining car rentals, private transfers and premium touristic tours with professionalism, comfort and flexibility.'}
        </p>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .why-card {
          animation: fadeUp 0.6s ease-out both;
        }
        .why-card:nth-child(1) { animation-delay: 0.1s; }
        .why-card:nth-child(2) { animation-delay: 0.2s; }
        .why-card:nth-child(3) { animation-delay: 0.3s; }
        .why-card:nth-child(4) { animation-delay: 0.4s; }
      `}</style>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
        {whyChooseCards.map((card, i) => (
          <div key={i} className="why-card group backdrop-blur-sm rounded-xl p-7 sm:p-8 hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 cursor-default" style={{ backgroundColor: 'rgba(255,255,255,0.08)', borderWidth: '1px', borderColor: 'rgba(255,255,255,0.15)' }}>
            <div className="w-12 h-12 rounded-full bg-[#10B981]/15 flex items-center justify-center mb-5 group-hover:bg-[#10B981]/25 transition-colors">
              <svg className="w-6 h-6 text-[#10B981]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d={card.icon} />
              </svg>
            </div>
            <h3 className="font-display text-lg font-bold text-white mb-2">{isRo ? card.titleRo : card.titleEn}</h3>
            <p className="text-white/55 text-sm leading-relaxed">{isRo ? card.descRo : card.descEn}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ── Google Reviews ────────────────────────────────── */

export const GoogleReviews = ({ isRo }) => {
  const [current, setCurrent] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const total = googleReviews.length;

  const next = useCallback(() => setCurrent(i => (i + 1) % total), [total]);
  const prev = useCallback(() => setCurrent(i => (i - 1 + total) % total), [total]);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);

  const getInitials = (name) => name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  const getColor = (name) => {
    const colors = ['#4285F4', '#EA4335', '#FBBC05', '#34A853', '#8E44AD', '#E67E22'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="google-reviews-section">
      <div className="absolute inset-0 parallax-bg" style={{ backgroundImage: 'url(/images/hero-new.webp)' }}>
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.65), rgba(0,0,0,0.55), rgba(0,0,0,0.72))' }}></div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="text-center mb-14">
          <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            {isRo ? 'Recenzii Clienți' : 'Customer Reviews'}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {isRo ? 'Ce spun clienții noștri' : 'What our clients say'}
          </h2>
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="flex items-center gap-1">
              {[1,2,3,4,5].map(i => <Star key={i} className="w-6 h-6 text-[#FBBC04] fill-[#FBBC04]" />)}
            </div>
            <span className="text-white text-2xl font-bold">5.0</span>
            <span className="text-white/50 text-sm">/5</span>
          </div>
          <div className="flex items-center justify-center gap-2 mt-2">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-white/60 text-sm">Google Reviews</span>
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto px-14"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}>
          <button onClick={prev} data-testid="reviews-prev-btn"
            className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-colors z-10" style={{ backgroundColor: 'rgba(255,255,255,0.1)', borderWidth: '1px', borderColor: 'rgba(255,255,255,0.2)' }}>
            <ChevronLeft size={20} />
          </button>
          <button onClick={next} data-testid="reviews-next-btn"
            className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-colors z-10" style={{ backgroundColor: 'rgba(255,255,255,0.1)', borderWidth: '1px', borderColor: 'rgba(255,255,255,0.2)' }}>
            <ChevronRight size={20} />
          </button>

          <div className="overflow-hidden rounded-xl">
            <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${current * 100}%)` }}>
              {googleReviews.map((review, i) => (
                <div key={i} className="w-full flex-shrink-0">
                  <div className="backdrop-blur-sm rounded-xl p-8 sm:p-10" style={{ backgroundColor: 'rgba(255,255,255,0.10)', borderWidth: '1px', borderColor: 'rgba(255,255,255,0.15)' }}>
                    <div className="flex items-center gap-1 mb-5">
                      {[1,2,3,4,5].map(s => (
                        <Star key={s} className={`w-5 h-5 ${s <= review.rating ? 'text-[#FBBC04] fill-[#FBBC04]' : 'text-white/20'}`} />
                      ))}
                    </div>
                    <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-8 italic">"{review.text}"</p>
                    <div className="flex items-center gap-4">
                      <div className="w-11 h-11 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: getColor(review.name) }}>
                        {getInitials(review.name)}
                      </div>
                      <div>
                        <p className="text-white font-semibold text-sm">{review.name}</p>
                        <p className="text-white/40 text-xs">{review.timeAgo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-8">
            {googleReviews.map((_, i) => (
              <button key={i} onClick={() => setCurrent(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all ${i === current ? 'bg-[#10B981] w-6' : 'bg-white/30 hover:bg-white/50'}`}
                data-testid={`reviews-dot-${i}`} />
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <a href="https://share.google/qWAGU45LXCCn0dlhA" target="_blank" rel="noopener noreferrer" data-testid="review-google-btn"
            className="inline-flex items-center gap-2.5 bg-white text-[#0D1B3E] font-medium px-6 py-3 rounded shadow-sm hover:shadow-md transition-all text-sm">
            <span>Review us on</span>
            <svg className="w-[60px] h-5 flex-shrink-0" viewBox="0 0 272 92">
              <path fill="#4285F4" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
              <path fill="#EA4335" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
              <path fill="#FBBC05" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"/>
              <path fill="#4285F4" d="M225 3v65h-9.5V3h9.5z"/>
              <path fill="#34A853" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"/>
              <path fill="#EA4335" d="M35.29 41.19V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49-.01z"/>
            </svg>
          </a>
          <a href="https://www.trustpilot.com/review/montreon.ro" target="_blank" rel="noopener noreferrer" data-testid="review-trustpilot-btn"
            className="inline-flex items-center gap-2.5 bg-white text-[#0D1B3E] font-medium px-6 py-3 rounded shadow-sm hover:shadow-md transition-all text-sm">
            <span>Review us on</span>
            <span className="inline-flex items-center gap-1">
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="4" fill="#00B67A"/>
                <path d="M20 8l3.5 10.8H35l-9.3 6.7 3.5 10.8L20 29.5l-9.2 6.8 3.5-10.8L5 18.8h11.5L20 8z" fill="#fff"/>
                <path d="M27.2 29.3l-1.4-4.3L20 29.5l7.2-0.2z" fill="#005128"/>
              </svg>
              <span className="font-bold text-[#191919] text-sm">Trustpilot</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

/* ── FAQ ───────────────────────────────────────────── */

export const FAQ = ({ isRo, items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(prev => prev === i ? null : i);
  const data = items || faqItems;

  return (
    <section className="py-20 sm:py-28 bg-white" data-testid="faq-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">FAQ</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0D1B3E]">
              {isRo ? 'Întrebări Frecvente' : 'Frequently Asked Questions'}
            </h2>
          </div>
          <div className="space-y-3">
            {data.map((item, i) => (
              <div key={i} data-testid={`faq-item-${i}`}
                className="border border-gray-200 rounded-xl overflow-hidden transition-colors hover:border-[#10B981]/30">
                <button onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  data-testid={`faq-toggle-${i}`}>
                  <span className="font-display text-sm sm:text-base font-semibold text-[#0D1B3E]">{isRo ? item.qRo : item.qEn}</span>
                  <ChevronDown size={20}
                    className={`text-[#10B981] flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} />
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${openIndex === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-gray-500 text-sm leading-relaxed">{isRo ? item.aRo : item.aEn}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ── All Shared Sections (convenience wrapper) ─────── */

const SharedSections = ({ language }) => {
  const isRo = language === 'ro';
  return (
    <>
      <OurServices isRo={isRo} />
      <WhyChoose isRo={isRo} />
      <GoogleReviews isRo={isRo} />
      <FAQ isRo={isRo} />
    </>
  );
};

export default SharedSections;
